import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { _CreditAccountvdos } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _Affiliate, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";

export const CreditAffiliate = () => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_Affiliate);
    const single = Singleton.getInstance();
    const [IDAccount, setIDAccount] = useState<number>(null);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        const props = {
            IDAccount: IDAccount
        }

        instance.getCreditAffiliateByProps(paginador.page, records, _single.cleanMap(props)).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (records));
                    paginador.setRegiPerPage(records)

                    setLista(resp.List)
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDCreditAffiliate', visible: false, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'Nit', visible: true,mask:MASK_NUMBER },
        { title: 'Fecha Expedición', property: 'FechaExpedicion', visible: true },
        { title: 'Afiliado', property: 'EntityName', visible: true },
        { title: 'Fecha Nacimiento', property: 'FechaNacimiento', visible: true },
        { title: 'Caja Nominadora', property: 'CajaNominadoraName', visible: true },
        { title: 'Grado', property: 'GradoPersona', visible: true },
        { title: 'Fecha Inicio Servicio', property: 'FechaInicioServicio', visible: true },
        { title: 'Tiempo en Servicio', property: 'TiempoServicio', visible: true },
        { title: 'Correo Personal', property: 'CorreoPersonal', visible: true },
        { title: 'Correo Institucional', property: 'CorreoInstitucional', visible: true },
        { title: 'Dto. Trabajo', property: 'DepartamentoTrabajo', visible: true },
        { title: 'Pais', property: 'PaisTrabajo', visible: true },
        { title: 'Dir. Residencia', property: 'DireccionResidencia', visible: true },
        { title: 'Tipo Vivienda', property: 'TipoVivienda', visible: true },
        { title: 'Tel. Vivienda', property: 'TelefonoVivienda', visible: true },
        { title: 'Estrato', property: 'EstratoResidencia', visible: true },
        { title: 'Dir. Trabajo', property: 'DireccionTrabajo', visible: true },
        { title: 'Tel. Trabajo', property: 'TelOficina', visible: true },
        { title: 'Estado Civil', property: 'EstadoCivil', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver/Editar Información', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true, name: `Ver/Actualizar Información del Usuario ${bean.EntityName}` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Afiliados">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={IDAccount} onChange={(e) => { setIDAccount(e.IDAccount) }} label="Tercero" />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton value="Buscar" icon="ri-file-add-line" eventClick={getLista} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                         next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    />


                    <Modal modal={modal} updateModal={setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <PersonalAccountData idAffiliate={bean.IDAccount} />
                            </div>
                        </div>
                    </Modal>


                </div>

            </div>
        </BasicPage>
    )
}